<template>
  <div class="skeleton-loader"></div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "SkeletonLoader",
});
</script>

<style lang="scss" scoped>
.skeleton-loader {
  width: 100%;
  height: 100%;
  min-height: 60px;
  border-radius: 4px;
  margin: 10px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite ease-in-out;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
